module.exports = __webpack_public_path__ + "img/1.f1a9ed2d.jpg";